// Generated types for RequirementMatchTask
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { EntityMatchTaskReadAPI, EntityMatchTaskWriteAPI } from './entitymatchtask';
import { EntityMatchTaskReadAPISchemaObject, EntityMatchTaskWriteAPISchemaObject } from './entitymatchtask';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface RequirementMatchTaskReadAPI extends EntityMatchTaskReadAPI {
}

export interface RequirementMatchTaskWriteAPI extends EntityMatchTaskWriteAPI {
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const RequirementMatchTaskReadAPISchema: z.ZodType<RequirementMatchTaskReadAPI> = EntityMatchTaskReadAPISchemaObject.extend({}).passthrough();

export const RequirementMatchTaskWriteAPISchema: z.ZodType<RequirementMatchTaskWriteAPI> = EntityMatchTaskWriteAPISchemaObject.extend({}).passthrough();
